export class TenderTabInformationDto {
    supplierId: number;
    noticeId: number;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/tenders/tender.tab.information.model.ts